// src/hooks/useAuth.js
import { configureToken, getUserToken, signUp, getProfile } from 'api';
import { useProfile } from '../context';

export const useAuth = () => {
  const { setProfile } = useProfile();

  const doLogin = async (data) => {
    const response = await getUserToken(data);
    const token = response.access;
    localStorage.setItem('token', response.access);
    localStorage.setItem('refreshToken', response.refresh);
    configureToken(token);
  
    // Fetch profile after successful login
    const profile = await getProfile();
    setProfile(profile);
    return response;
  };

  const doSignup = async (data) => {
    let response = await signUp(data);
    console.log('Signup ', response);
    response = await getUserToken(data);
    console.log('Inmediate login ', response);
    const token = response.access;
    localStorage.setItem('token', response.access);
    localStorage.setItem('refreshToken', response.refresh);
    configureToken(token);
    const profile = await getProfile();
    setProfile(profile);
    return response;
  };

  return { doLogin, doSignup };
};
